import React from 'react';
import { IconProps } from '../types';

interface CustomIconProps extends IconProps {
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const SsfRulerOff = React.memo<CustomIconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
    width,
    height,
    role = 'img',
    'aria-hidden': ariaHidden = false,
  }) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7C2 6.44772 2.44772 6 3 6H17C17.5523 6 18 6.44772 18 7V13C18 13.5523 17.5523 14 17 14H3C2.44772 14 2 13.5523 2 13V7ZM3.2 12.8V7.2H4.4V10C4.4 10.3314 4.66863 10.6 5 10.6C5.33137 10.6 5.6 10.3314 5.6 10V7.2H6.9V8.8C6.9 9.13137 7.16863 9.4 7.5 9.4C7.83137 9.4 8.1 9.13137 8.1 8.8V7.2H9.4V10C9.4 10.3314 9.66863 10.6 10 10.6C10.3314 10.6 10.6 10.3314 10.6 10V7.2H11.9V8.8C11.9 9.13137 12.1686 9.4 12.5 9.4C12.8314 9.4 13.1 9.13137 13.1 8.8V7.2H14.4V10C14.4 10.3314 14.6686 10.6 15 10.6C15.3314 10.6 15.6 10.3314 15.6 10V7.2H16.8V12.8H3.2Z"
        fill="white"
      />
    </svg>
  ),
);

SsfRulerOff.displayName = 'SsfRulerOff';
